import React from 'react';
import {
  LAPTOP,
  TABLET,
  TABLET_S,
  MOBILE_L,
  MOBILE_M,
  MOBILE_S
} from '../../hooks/useWidthMeasurement';

const contentLoaderConfig = {
  [LAPTOP]: {
    height: 90,
    styleName: 'laptop',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="60" width="939" height="10" />
          <rect x="0" y="80" width="896" height="10" />
        </>
      ) : (
        <>
          <rect x="0" y="60" width="1010" height="10" />
          <rect x="0" y="80" width="956" height="10" />
        </>
      ),
    circle: () => <circle cx="23" cy="23" r="23" />,
    shorterRects: () => (
      <>
        <rect x="62" y="7" width="109" height="10" />
        <rect x="62" y="27" width="226" height="10" />
      </>
    )
  },
  [TABLET]: {
    height: 105,
    styleName: 'tablet',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="69" width="939" height="11" />
          <rect x="0" y="91" width="896" height="11" />
        </>
      ) : (
        <>
          <rect x="0" y="69" width="1010" height="11" />
          <rect x="0" y="91" width="956" height="11" />
        </>
      ),
    circle: () => <circle cx="28" cy="28" r="28" />,
    shorterRects: () => (
      <>
        <rect x="75" y="10" width="109" height="11" />
        <rect x="75" y="32" width="226" height="11" />
      </>
    )
  },
  [TABLET_S]: {
    height: 165,
    styleName: 'tablet-s',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="110" width="939" height="19" />
          <rect x="0" y="145" width="896" height="19" />
        </>
      ) : (
        <>
          <rect x="0" y="110" width="1010" height="19" />
          <rect x="0" y="145" width="956" height="19" />
        </>
      ),
    circle: () => <circle cx="40" cy="40" r="40" />,
    shorterRects: () => (
      <>
        <rect x="117" y="17" width="109" height="19" />
        <rect x="117" y="52" width="226" height="19" />
      </>
    )
  },
  [MOBILE_L]: {
    height: 200,
    styleName: 'mobile-l',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="130" width="939" height="22" />
          <rect x="0" y="170" width="896" height="22" />
        </>
      ) : (
        <>
          <rect x="0" y="130" width="1010" height="22" />
          <rect x="0" y="170" width="956" height="22" />
        </>
      ),
    circle: () => <circle cx="53" cy="53" r="53" />,
    shorterRects: () => (
      <>
        <rect x="145" y="25" width="109" height="22" />
        <rect x="145" y="65" width="226" height="22" />
      </>
    )
  },
  [MOBILE_M]: {
    height: 280,
    styleName: 'mobile-m',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="180" width="939" height="27" />
          <rect x="0" y="240" width="896" height="27" />
        </>
      ) : (
        <>
          <rect x="0" y="180" width="1010" height="27" />
          <rect x="0" y="240" width="956" height="27" />
        </>
      ),
    circle: () => <circle cx="85" cy="73" r="66" />,
    shorterRects: () => (
      <>
        <rect x="200" y="25" width="109" height="27" />
        <rect x="200" y="85" width="226" height="27" />
      </>
    )
  },
  [MOBILE_S]: {
    height: 300,
    styleName: 'mobile-s',
    longerRects: (isChildrenLoader) =>
      isChildrenLoader ? (
        <>
          <rect x="0" y="180" width="939" height="32" />
          <rect x="0" y="240" width="896" height="32" />
        </>
      ) : (
        <>
          <rect x="0" y="180" width="1010" height="32" />
          <rect x="0" y="240" width="956" height="32" />
        </>
      ),
    circle: () => <circle cx="74" cy="74" r="74" />,
    shorterRects: () => (
      <>
        <rect x="200" y="25" width="109" height="32" />
        <rect x="200" y="85" width="226" height="32" />
      </>
    )
  }
};

export default contentLoaderConfig;
